<template>
  <el-dialog
    class="process-mind-map-dialog process-mind-map-source-dialog material-plan-dialog"
    v-dialogDrag
    :visible.sync="innerVisible"
    width="96vw"
    append-to-body
    top="4vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @open="loadData"
    @closed="resetData">
    <div slot="title" class="material-plan-dialog__title">
      <span>{{ $LANG('', '物料计划') }}</span>
    </div>
    <div class="material-plan-dialog__body">
      <div class="material-plan-dialog__filters">
        <el-input
          v-model="filters.materialName"
          size="mini"
          clearable
          :placeholder="$LANG('', '物料名称')"
          :aria-label="$LANG('', '物料名称')">
        </el-input>
        <el-input
          v-model="filters.materialCode"
          size="mini"
          clearable
          :placeholder="$LANG('', '物料编码')"
          :aria-label="$LANG('', '物料编码')">
        </el-input>
        <el-input
          v-model="filters.purchaseOrder"
          size="mini"
          clearable
          :placeholder="$LANG('', '采购单号')"
          :aria-label="$LANG('', '采购单号')">
        </el-input>
        <el-select
          class="material-plan-dialog__status-filter"
          v-model="filters.status"
          size="mini"
          clearable
          filterable
          :placeholder="$LANG('', '状态')"
          :aria-label="$LANG('', '状态')">
          <el-option
            v-for="status in statusOptions"
            :key="status"
            :label="status"
            :value="status">
          </el-option>
        </el-select>
        <el-button class="material-plan-dialog__reset" size="mini" @click="resetFilters">{{ $LANG('', '重置') }}</el-button>
      </div>
      <el-table
        :data="filteredTableData"
        border
        size="small"
        ref="detailTable"
        class="custom-table-border material-plan-dialog__table"
        v-loading="loading"
        :element-loading-text="$LANG('1959', '加载中')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 251, 255, 0.8)"
        show-summary
        :summary-method="getSummary"
        :cell-style="{ padding: '2px' }"
        :header-cell-style="headStyle"
        :row-class-name="tabRowClass"
        cell-class-name="clearPadding2"
        height="calc(88vh - 97px)"
        highlight-current-row>
        <el-table-column :label="$LANG('0310', '序号')" type="index" width="60" fixed></el-table-column>
        <el-table-column
          v-for="item in visibleColumns"
          :key="item.key"
          :prop="item.key"
          :label="item.title"
          show-overflow-tooltip
          :align="item.align"
          :sortable="item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N'"
          :min-width="getColumnMinWidth(item)">
          <template slot-scope="scope">
            <el-checkbox
              v-if="item.edcss === 'checkbox'"
              disabled
              true-label="Y"
              false-label="N"
              v-model="scope.row[item.key]">
            </el-checkbox>
            <el-tag v-else-if="item.key === 'POSTFG'" size="mini" effect="plain" :type="getStatusTagType(scope.row[item.key])">{{ displayText(scope.row[item.key]) }}</el-tag>
            <span v-else v-text="displayText(scope.row[item.key])"></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import { getTabColOrData } from '../../api/user'

export default {
  name: 'MaterialPlanDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    node: {
      type: Object,
      default: function () { return null }
    },
    orderRow: {
      type: Object,
      default: function () { return null }
    }
  },
  data: function () {
    return {
      loading: false,
      columns: [],
      tableData: [],
      filters: {
        materialName: '',
        materialCode: '',
        purchaseOrder: '',
        status: ''
      },
      statusOptions: ['未开始', '进行中', '已完成', '异常', '加急']
    }
  },
  computed: {
    innerVisible: {
      get: function () { return this.visible },
      set: function (value) { this.$emit('update:visible', value) }
    },
    visibleColumns: function () {
      return this.columns.filter(function (item) { return item.thide === 'N' })
    },
    filteredTableData: function () {
      var materialName = String(this.filters.materialName || '').trim().toLowerCase()
      var materialCode = String(this.filters.materialCode || '').trim().toLowerCase()
      var purchaseOrder = String(this.filters.purchaseOrder || '').trim().toLowerCase()
      var status = String(this.filters.status || '').trim()
      return this.tableData.filter(function (row) {
        var rowMaterialName = String(row.MATNM || '').toLowerCase()
        var rowMaterialCode = String(row.MATNO || '').toLowerCase()
        var rowPurchaseOrder = String(row.PONO || '').toLowerCase()
        var rowStatus = String(row.POSTFG || '').trim()
        return (!materialName || rowMaterialName.indexOf(materialName) !== -1) &&
          (!materialCode || rowMaterialCode.indexOf(materialCode) !== -1) &&
          (!purchaseOrder || rowPurchaseOrder.indexOf(purchaseOrder) !== -1) &&
          (!status || rowStatus === status)
      })
    },
    vUsername: function () {
      return this.$cookies.get('v_telno')
    },
  
    tableUrl: function () {
      return  'xuper_auth/getTableRecMany'
    }
  },
  methods: {
    resetData: function () {
      this.loading = false
      this.columns = []
      this.tableData = []
      this.resetFilters()
    },
    resetFilters: function () {
      this.filters.materialName = ''
      this.filters.materialCode = ''
      this.filters.purchaseOrder = ''
      this.filters.status = ''
    },
    loadData: function () {
      this.loading = true
      Promise.all([this.loadColumns(), this.loadRows()]).then(function (result) {
        this.columns = result[0] || []
        this.tableData = result[1] || []
        this.$nextTick(function () {
          if (this.$refs.detailTable && this.$refs.detailTable.doLayout) this.$refs.detailTable.doLayout()
        })
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.loading = false
      }.bind(this))
    },
    loadColumns: function () {
      return getTabColOrData(this.tableUrl,   'v_sys_form_fld', 'idseq', '16572', 'lstseq', '2097', '', '', ' order by sortby,lstseq').then(function (res) {
        var list = (res && res.result) || []
        return list.map(function (item) {
          return {
            title: this.$translate.getColTitle(item, this.$store.state.lang),
            key: item.key,
            align: item.align,
            width: item.width,
            thide: item.THIDE,
            edcss: item.EDCSS,
            sortable: item.SORTABLE
          }
        }.bind(this))
      }.bind(this))
    },
    loadRows: function () {
      var payload
      try {
        payload = this.getDynamicPayload()
      } catch (error) {
        return Promise.resolve([])
      }
      return getTabColOrData(
        this.tableUrl,
        payload.p_table,
        payload.p_key,
        payload.p_value,
        payload.p_key2,
        payload.p_value2,
        '',
        '',
        ''
      ).then(function (res) {
        return (res && res.result) || []
      })
    },
    getNodeData: function () {
      return (this.node && this.node.nodeData) || {}
    },
    getOrderData: function () {
      return this.orderRow || {}
    },
    getRequiredSourceParams: function () {
      var row = this.getNodeData()
      var orderRow = this.getOrderData()
      var params = {
        ORDNO: row.ORDNO || row.IDNO || row.REFIDNO || orderRow.ORDNO || orderRow.IDNO || orderRow.REFIDNO,
        ORDSEQ: row.ORD_IDSEQ || row.ORDSEQ || orderRow.IDSEQ || orderRow.ORD_IDSEQ || orderRow.ORDSEQ,
        CORPID: row.CORPID || orderRow.CORPID || this.$cookies.get('v_corpid')
      }
      var missing = []
      Object.keys(params).forEach(function (key) {
        if (params[key] === undefined || params[key] === null || params[key] === '') missing.push(key)
      })
      if (missing.length) throw new Error('MISSING_SOURCE_PARAMS')
      return params
    },
    getDynamicPayload: function () {
      var params = this.getRequiredSourceParams()
      return {
        p_key: 'ordseq',
        p_value: params.ORDSEQ,
        p_key2: 'corpid',
        p_value2: params.CORPID,
        p_table: 'V_po_reqdtl'
      }
    },
    escapeQueryValue: function (value) {
      return String(value === undefined || value === null ? '' : value).trim().replace(/'/g, "''")
    },
    displayText: function (value) {
      return value === undefined || value === null || value === '' ? '-' : value
    },
    getColumnMinWidth: function (item) {
      item = item || {}
      var configuredWidth = parseInt(item.width, 10) || 0
      var title = String(item.title || '')
      var isSortable = item.edcss !== 'checkbox' && item.key !== 'RN' && item.sortable === 'N'
      var titleWidth = Array.from(title).reduce(function (total, char) {
        return total + (/[\u4e00-\u9fff]/.test(char) ? 14 : 8)
      }, 0)
      var headerWidth = titleWidth + (isSortable ? 22 : 0) + 24
      if (item.key === 'POSTFG') headerWidth = Math.max(headerWidth, 88)
      return Math.max(configuredWidth, headerWidth)
    },
    getPostStatus: function (row) {
      return row && (row.POSTFG || row.postfg)
    },
    getStatusTagType: function (status) {
      if (status === '进行中') return 'primary'
      if (status === '已完成') return 'success'
      if (status === '异常') return 'warning'
      if (status === '加急') return 'danger'
      return 'info'
    },
    tabRowClass: function (params) {
      var status = this.getPostStatus(params.row || {})
      if (status === '未开始') return 'row-gray'
      if (status === '进行中') return 'row-blue'
      if (status === '已完成') return 'row-green'
      if (status === '异常') return 'row-yellow'
      if (status === '加急') return 'row-red'
      return 'row-gray'
    },
    headStyle: function (params) {
      var column = params.column || {}
      if (column.property === 'REQQTY') return 'color:red'
    },
    getSummary: function (param) {
      var sums = []
      param.columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = this.$LANG('0280', '合计')
          return
        }
        if (column.property !== 'REQQTY') return
        var values = param.data.map(function (item) { return Number(item[column.property]) })
        var sumValue = values.reduce(function (prev, curr) {
          if (!isNaN(curr)) return Number(prev) + Number(curr)
          return prev
        }, 0)
        sums[index] = sumValue ? sumValue.toLocaleString() : ''
      }.bind(this))
      return sums
    }
  }
}
</script>

<style scoped>
.material-plan-dialog__title {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 56px 0 20px;
  border-bottom: 1px solid #ebeef5;
  background: #fff;
  color: #1f2f3d;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
}
.material-plan-dialog__body {
  min-height: 70vh;
}
.material-plan-dialog__filters {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 8px;
}
.material-plan-dialog__filters .el-input,
.material-plan-dialog__filters .el-select {
  width: 150px;
}
.material-plan-dialog__table {
  width: 100%;
}
</style>

<style lang="less">
.process-mind-map-dialog.material-plan-dialog {
  .material-plan-dialog__filters .el-input--mini .el-input__inner {
    height: 28px !important;
    min-height: 28px !important;
    line-height: 28px !important;
    font-size: 12px !important;
  }
  .material-plan-dialog__filters .el-input--mini .el-input__icon {
    height: 28px;
    line-height: 28px;
  }
  .material-plan-dialog__filters .el-input__suffix-inner {
    display: inline-flex;
    align-items: center;
    height: 100%;
    vertical-align: top;
  }
  .material-plan-dialog__status-filter,
  .material-plan-dialog__status-filter .el-input {
    height: 28px;
  }
  .material-plan-dialog__status-filter .el-input__suffix,
  .material-plan-dialog__status-filter .el-select__caret {
    height: 28px !important;
    line-height: 28px !important;
  }
  .material-plan-dialog__reset {
    height: 28px !important;
    min-height: 28px !important;
    padding: 0 12px !important;
    font-size: 12px !important;
    line-height: 28px !important;
  }
  .el-table th > .cell {
    white-space: nowrap;
    word-break: keep-all;
  }

  .el-table .row-red {
    color: red;
  }
  .el-table .row-gray {
    color: #909399;
  }
  .el-table .row-blue {
    color: blue;
  }
  .el-table .row-green {
    color: green;
  }
  .el-table .row-yellow {
    color: rgb(255, 165, 0);
  }
}
</style>
